import React from 'react';
import PropTypes from 'prop-types';

const Context = React.createContext(null);

export {Context};

export default class Repository extends React.Component {

  constructor(props) {
    super(props);

    this.open.bind(this);
    this.close.bind(this);
    this.register.bind(this);
  }

  modals = {};

  register(name, modal) {
    if (name in this.modals) {
      throw new Error('Provided "name" is already taken.');
    }

    this.modals[name] = modal;
  }

  unregister(name) {
    if (typeof this.modals[name] !== 'undefined') {
      delete this.modals[name];
    }
  }
  
  open(name) {
    const {[name]: model} = this.modals;

    if (model && typeof model.open === 'function') {
      model.open();
    }
    else {
      throw new Error(`Modal with name "${name}" is not registered.`);
    }
  }

  close(name) {
    const {[name]: model} = this.modals;

    if (model && typeof model.close === 'function') {
      model.close();
    }
    else {
      throw new Error(`Modal with name "${name}" is not registered.`);
    }
  }

  render() {
    return (
      <Context.Provider value={this}>
        <React.Fragment>
          {this.props.children}
        </React.Fragment>
      </Context.Provider>
    )
  }
}

Repository.propTypes = {
  children: PropTypes.node,
};
